/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line





   $(document).on('click', '.buynow-btn', function(e) {
      e.preventDefault();
      var variant_id = $('[data-product-select]').val();
      var quantity = 1; 
          
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          'id': variant_id,
          'quantity': quantity
        },
        success: function(response) {
          
                
                window.location.href = '/checkout';
            
        },
        error: function(xhr, status, error) {
          console.log(xhr.responseText);
        }
      });
    });

  $(document).on('click', '.buynow-sticky', function(e) {
      e.preventDefault();
      $(".btn-atc").click();
  });

  $(document).on('click', '.topb-close', function(e) {
      $('.top-ann').hide();
  });

// Prevent zooming with the mouse wheel
window.addEventListener('wheel', function (e) {
    if (e.ctrlKey) {
        e.preventDefault();
    }
}, { passive: false });

// Prevent zooming with keyboard shortcuts
window.addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) {
        e.preventDefault();
    }
});

// Prevent pinch-to-zoom
window.addEventListener('touchstart', function (e) {
    if (e.touches.length > 1) {
        e.preventDefault();
    }
}, { passive: false });

window.addEventListener('gesturestart', function (e) {
    e.preventDefault();
});



  var shlink = document.querySelector('.share-link');

  if(shlink){
    shlink.addEventListener('click', () => {
      if (navigator.share) {
        navigator.share({
          title: document.title,
          url: window.location.href
        }).catch((error) => console.error('Error sharing:', error));
      } else {
        // Fallback if the Web Share API is not supported
        alert('Sharing is not supported on this browser. Please copy the link manually.');
      }
    });
  }
  
  
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
